import { render, staticRenderFns } from "./GameReset.vue?vue&type=template&id=3381dd9b&scoped=true"
import script from "./GameReset.vue?vue&type=script&lang=js"
export * from "./GameReset.vue?vue&type=script&lang=js"
import style0 from "./GameReset.vue?vue&type=style&index=0&id=3381dd9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3381dd9b",
  null
  
)

export default component.exports